// extracted by mini-css-extract-plugin
module.exports = {"header":"header-2UIi7hti","stickyTop":"stickyTop-17XZeqsr","headerBox":"headerBox-aYUtmYSJ","logo":"logo-IOU8xGvW","botton":"botton-3P7DloLX"};